export default class CreatePurchaseOrderCheckIn{
    poCode : string;
    numOfPacks : number;
    arrivedAt : Date;
    note : string;
    containerNumber : string;
    driverName: string;
    driverPhone: string;

    poMedias : Array<any>;
}